import React from 'react';
import { connect } from 'react-redux';
import { NoOp } from 'component/common/ActivitiesConstants';
import { mapDispatchToProps, mapStateToProps, SearchBarProps } from 'component/common/SearchBar/SearchBar.selectors';
import TextSearchOverlay from 'component/common/TextSearch/TextSearchOverlay';
import { Box, SearchField } from '@drone-js/core';
import { useLocation } from 'react-router-dom';
import SearchBoxPopover from 'component/common/SearchBox/SearchBoxPopover';
import LocationDeniedInfoModal from 'component/common/TextSearch/TextSearchResult/NearMe/LocationDeniedInfoModal';
import { getCityIdQueryParams, getKeywordQueryParams } from 'gql/service/graph/activityService';
// eslint-disable-next-line import/no-restricted-paths
import PopularSubcategoriesSection from 'component/common/PopularSubcategoriesSection/PopularSubcategoriesSection';

const SearchBar: React.FC<SearchBarProps> = React.memo((props) => {
    const {
        searchText,
        cms,
        onSearchTextInputClick,
        onSearchTextInputSeen,
        screenSize,
        onSearchResultSelect,
        onKeywordResultSelect,
        onGlobalKeywordResultSelect,
        popularActivities,
        suggestionResult,
        trailingAsset,
        isNearByEnabled,
        isDisabledGlobalKeywordSearch,
        shouldShowPopularCategories,
        placeholderText,
        isCityNamePlaceHolderEnabled,
    } = props;
    const location = useLocation();
    const locationSearch = location.search;
    const [searchBarInput, setSearchBarInput] = React.useState<string>(searchText);

    React.useEffect(() => {
        onSearchTextInputSeen();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    React.useEffect(() => {
        const keywordParam = getKeywordQueryParams(locationSearch) || '';
        const cityIdParam = getCityIdQueryParams(locationSearch) || '';
        if (keywordParam && !cityIdParam) {
            setSearchBarInput(keywordParam);
        }
    }, [locationSearch]);

    const openTextSearchPopover = () => {
        onSearchTextInputClick();
    };

    return (
        <>
            <Box flexDirection="column" width="100%" display="flex">
                <Box flexDirection="row" width="100%" display="flex" alignItems="center">
                    <>
                        {screenSize.tabletOrDesktop ? (
                            <SearchBoxPopover
                                query={searchBarInput || ''}
                                setSearchText={NoOp}
                                setSelectedResult={onSearchResultSelect}
                                width="696px"
                                popularActivities={popularActivities}
                                data-testid="activities-header-search-bar-text-input"
                                dataElementName="activities-header-search-bar-text-input"
                                isHomeSearchBox={false}
                                placeholderText={placeholderText || cms[238402]}
                                onKeywordResultSelect={onKeywordResultSelect}
                                onGlobalKeywordResultSelect={onGlobalKeywordResultSelect}
                                isDisabledGlobalKeywordSearch={isDisabledGlobalKeywordSearch}
                            />
                        ) : (
                            <SearchField
                                width="100%"
                                data-testid="activities-header-search-bar-text-input"
                                data-element-name="activities-header-search-bar-text-input"
                                variant="picker"
                                onChange={NoOp}
                                leadingAsset={{
                                    id: 'fill.symbol.search',
                                }}
                                label={cms[238402]}
                                onClick={openTextSearchPopover}
                                onKeyDown={openTextSearchPopover}
                                inputText={isCityNamePlaceHolderEnabled ? searchBarInput : searchBarInput || cms[126801]}
                                placeholderText={placeholderText || cms[238402]}
                            />
                        )}
                    </>
                    {trailingAsset}
                </Box>
                {shouldShowPopularCategories && <PopularSubcategoriesSection cms={cms} />}
            </Box>
            <TextSearchOverlay
                selectedResult={suggestionResult}
                setSearchText={NoOp}
                setSelectedResult={onSearchResultSelect}
                popularActivities={popularActivities}
                onKeywordResultSelect={onKeywordResultSelect}
                onGlobalKeywordResultSelect={onGlobalKeywordResultSelect}
                isDisabledGlobalKeywordSearch={isDisabledGlobalKeywordSearch}
            />
            {isNearByEnabled && <LocationDeniedInfoModal />}
        </>
    );
});

SearchBar.displayName = 'SearchBar';

export default connect(mapStateToProps, mapDispatchToProps)(SearchBar);
